module.exports = require("@mui/material/colors");